<p-toast></p-toast>
<app-nav-header></app-nav-header>
<div class="wrapper">
	<div class="main">
		<div id="magneticCasePage">
			<ng-container *ngIf="mode === 'list'">
				<div class="eyebrow">大阿姨鑑定卡周邊</div>
				<h1>鑑定卡專用磁鐵保護殼</h1>
				<p class="sub">拖曳殼體可 360° 查看，選好類型、尺寸、顏色與數量後按「加入清單」，可以一次選購多種規格再一起送出訂單。</p>

				<div class="studio">
					<div #stageEl class="stage">
						<ng-container *ngIf="isBrowser && threeReady; else fallbackTpl">
							<canvas
								#canvasEl
								aria-label="磁鐵殼 3D 預覽，可拖曳旋轉"
								(pointerdown)="onPointerDown($event)"
								(pointermove)="onPointerMove($event)"
								(pointerup)="onPointerUp()"
								(pointercancel)="onPointerUp()"
							></canvas>
							<div
								class="stage-hint"
								[class.hidden]="!showHint"
							>
								<svg
									viewBox="0 0 24 24"
									fill="none"
									stroke="currentColor"
									stroke-width="2"
									stroke-linecap="round"
								>
									<path d="M3 12h18M7 8l-4 4 4 4M17 8l4 4-4 4" />
								</svg>
								拖曳旋轉
							</div>
						</ng-container>
						<ng-template #fallbackTpl>
							<div class="stage-fallback">3D 預覽載入失敗，請重新整理頁面後再試一次。</div>
						</ng-template>
					</div>

					<div class="panel">
						<div class="field">
							<div class="field-label">鑑定類型</div>
							<div class="grade-row">
								<button
									*ngFor="let g of grades"
									type="button"
									class="grade-chip"
									[class.active]="selectedGrade.id === g.id"
									(click)="selectGrade(g)"
								>
									<span
										class="label"
										[style.background]="g.label"
									>{{ g.id }}</span>
								</button>
							</div>
						</div>

						<div
							class="field"
							*ngIf="selectedGrade.id !== 'BGS'"
						>
							<div class="field-label">卡厚尺寸</div>
							<div class="size-row">
								<button
									*ngFor="let s of sizes"
									type="button"
									class="size-chip"
									[class.active]="selectedSize.id === s.id"
									(click)="selectSize(s)"
								>
									<span
										class="bar"
										[style.height.px]="s.bar"
									></span>
									<span class="txt">
										<b>{{ s.txt }}</b>
										<span>{{ s.cert }}</span>
									</span>
								</button>
							</div>
						</div>

						<div class="field">
							<div class="field-label">
								殼體顏色 <span class="val mono">{{ selectedColor.name }}</span>
							</div>
							<div class="swatch-row">
								<button
									*ngFor="let c of colors"
									type="button"
									class="swatch"
									[class.active]="selectedColor.id === c.id"
									[style.background]="swatchBg(c.hex)"
									[attr.aria-label]="c.name"
									(click)="selectColor(c)"
								></button>
							</div>
						</div>

						<div class="spec">
							<div>
								類型 <b>{{ selectedGrade.id }}</b>
								<ng-container *ngIf="selectedGrade.id !== 'BGS'"> · 尺寸 <b>{{ selectedSize.txt }}</b></ng-container>
								· 顏色 <b>{{ selectedColor.name }}</b>
							</div>
							<div>外框 <b>鋁合金 CNC</b> · 玻璃 <b>防爆強化 · 抗UV 99%</b> · 磁力 <b>N52 × 18 顆</b></div>
							<div *ngIf="currentVariant">
								單價 <b>NT$ {{ currentVariant.price }}</b> · 庫存 <b>{{ availableStock }}</b> 件
							</div>
							<div
								class="outOfStock"
								*ngIf="!currentVariant"
							>
								這個組合目前尚未開放販售
							</div>
						</div>

						<div class="buy-row">
							<div class="qty-stepper">
								<button
									type="button"
									(click)="changeQuantity(-1)"
								>−</button>
								<span>{{ quantity }}</span>
								<button
									type="button"
									(click)="changeQuantity(1)"
								>+</button>
							</div>
							<button
								class="cta"
								type="button"
								[disabled]="!currentVariant || availableStock <= 0"
								(click)="addToCartLine()"
							>{{ availableStock <= 0 && currentVariant ? '已售完' : '加入清單' }}</button>
						</div>
					</div>
				</div>

				<div class="checkoutArea">
					<div class="cartBox">
						<div class="titleBox">
							<p>已選清單</p>
						</div>
						<p
							class="emptyCart"
							*ngIf="cartLines.length <= 0"
						>
							目前清單是空的，選好規格後按「加入清單」
						</p>
						<div
							class="cartRow"
							*ngFor="let line of cartLines; let i = index"
						>
							<div class="cartRowInfo">
								<p class="cartRowTitle">{{ line.gradeId }} - {{ line.sizeLabel }} - {{ line.colorName }}</p>
								<p class="cartRowSub">NT$ {{ line.unitPrice }} × {{ line.quantity }}</p>
							</div>
							<div class="cartRowAmount">NT$ {{ line.unitPrice * line.quantity }}</div>
							<button
								type="button"
								class="removeBtn"
								(click)="removeCartLine(i)"
							>移除</button>
						</div>
						<ng-container *ngIf="cartLines.length > 0">
							<div class="cartSubRow">
								<span>商品小計</span>
								<span>NT$ {{ cartTotal }}</span>
							</div>
							<div class="cartSubRow">
								<span>運費</span>
								<span>NT$ {{ shippingFee }}</span>
							</div>
							<div class="cartTotalRow">
								<span>應付總額</span>
								<span class="amount">NT$ {{ grandTotal }}</span>
							</div>
						</ng-container>
					</div>

					<div
						class="buyerBox"
						*ngIf="cartLines.length > 0"
					>
						<div class="titleBox">
							<p>收件資訊</p>
						</div>
						<form
							[formGroup]="buyerForm"
							class="buyerFormGrid"
						>
							<div class="form-group">
								<label><span class="required">*</span>收件姓名</label>
								<input
									pInputText
									type="text"
									placeholder="請輸入收件姓名"
									formControlName="buyerName"
								/>
							</div>
							<div class="form-group">
								<label><span class="required">*</span>手機號碼</label>
								<input
									pInputText
									type="text"
									placeholder="請輸入手機號碼，ex: 0912345678"
									formControlName="buyerPhone"
								/>
							</div>
							<div class="form-group">
								<label><span class="required">*</span>電子郵件</label>
								<input
									pInputText
									type="text"
									placeholder="請輸入電子郵件，ex: bigaunt@gmail.com"
									formControlName="buyerEmail"
								/>
							</div>
							<div class="form-group">
								<label><span class="required">*</span>匯款帳號</label>
								<input
									pInputText
									type="text"
									placeholder="請輸入末5碼"
									formControlName="buyerBankAccount"
								/>
							</div>
							<div class="form-group">
								<label><span class="required">*</span>711店鋪</label>
								<input
									pInputText
									type="text"
									placeholder="請輸入門市名稱"
									formControlName="711Name"
								/>
							</div>
						</form>
						<div class="footerBox">
							<button
								class="cta"
								type="button"
								(click)="submitOrder()"
							>送出訂單</button>
						</div>
					</div>
				</div>
			</ng-container>

			<div
				class="successArea"
				*ngIf="mode === 'success'"
			>
				<p class="successTitle">訂購成功！！</p>
				<p>看到這個畫面即可進行匯款</p>
				<p>匯款資訊：(台新銀行)812-28881022569059</p>
			</div>
		</div>
	</div>
</div>
<app-footer *ngIf="mode !== 'success'"></app-footer>
